import { CustomPage } from "../../DashboardApp/types";

// @ts-ignore
import Assets from "./pages/Assets/Assets";

export const customPages = [
	{ moduleId: "0425f813-a956-4d0d-9180-12faad4fdf89", path: "list", content: <Assets /> },
] as CustomPage[];
